import Intercom, { show, showNewMessage } from '@intercom/messenger-js-sdk'
import type { SupportMessengerSession } from '../operations-types'

export function bootSupportChat(session: SupportMessengerSession) {
  if (session.provider !== 'intercom') return
  Intercom({ app_id: session.appId, intercom_user_jwt: session.token })
}

export function openSupportChat() {
  show()
}

export function openSupportChatWithMessage(message: string) {
  showNewMessage(message)
}
